import React, { useEffect, useState } from 'react';
import { fetchSMSOrderGoods } from 'lib/apis';
import cx from 'classnames';
import './index.scss';

interface Goods {
  imgUrl: string;
  hasConner: boolean;
  giftName: string;
}

const OrderGoods = ({ packageId }) => {
  const [goods, setGoods] = useState<Goods[]>([]);

  useEffect(() => {
    getSMSOrderGoods(packageId);
  }, []);

  const getSMSOrderGoods = async (packageId) => {
    const res = await fetchSMSOrderGoods({ packageId });

    if (res?.code !== 0) return;

    setGoods(res?.data.slice(0, 4));
  };

  return goods.length ? (
    <div
      className={cx({
        'order-goods': true,
      })}
    >
      {goods.map((gift) => (
        <div className="order-goods__item" key={gift?.imgUrl}>
          <img src={gift.imgUrl} alt="" />
          {!!gift.hasConner && <span className="fill" />}
        </div>
      ))}
    </div>
  ) : null;
};

export default OrderGoods;
